<template>
    <layout class="text-white">
        <!-- <section-hero :section-hero="sectionHero"></section-hero> -->
        <section-contact-form
            id="section-contact-form"
            :section-contact-form="sectionContactForm"
            :contact-info="contact" />
        <!-- <section-instagram
            :section-instagram="sectionInstagram"
            :external-links="$page.externalLinks" /> -->
    </layout>
</template>

<script>
import Layout from '@web/components/PageLayout';
// import SectionHero from '@web/pages/sections/ContactPage/SectionHero';
import SectionContactForm from '@whisper/components/contact/SectionContactForm';
// import SectionInstagram from '@web/pages/sections/shared/SectionInstagram';

export default {
  components: {
    Layout,
    // SectionHero,
    SectionContactForm,
    // SectionInstagram,
  },
  props: {
    sectionHero: {
      type: Object,
      required: true,
    },
    sectionContactForm: {
      type: Object,
      required: true,
    },
    contact: {
      type: Object,
      required: true,
    },
    sectionInstagram: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
#section-contact-form {
    margin-top: 152px;
}
</style>
